import React from 'react';
import styles from "./index.module.scss";

export default function index(props) {
    return (
        <div className={`${styles.container} ${props.parent == "botStore" ? "botStoreLoader" : null}`}>
            <div className={`${styles.loader} ${styles.loader3}`}></div>
        </div>
    )
}
